import { IComponentOptions } from 'angular';
import { GradPlanningWizardTransferCtrl } from './grad-planning-wizard-transfer.controller';

export const GradPlanningWizardTransferComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    currentUser: '<',
  },
  controller: GradPlanningWizardTransferCtrl,
  template: require('./grad-planning-wizard-transfer.html'),
};
